<template>
	<section :class="['block-wrapper', componentClass, colorMode, {visible: visible, ready: ready}]">
		<block-title :columns="'medium-8'" :blockTitle="data.title">
				
		</block-title>
		<div class="row">
			<div id="job-offers-wrapper" class="columns small-12">	
				<iframe 
					id="job-offers-iframe" 
					style="overflow: auto!important;"
					:src="'https://stem.no/rutericons/abg-iframe/job-offers.html'" 
					:height="this.iframeHeight"
					frameborder="0"
					allow="autoplay; fullscreen" allowfullscreen>
				</iframe>
				<!-- <div class="dc-cc-content-blocked" v-if="!this.$store.state.cookiePreferences.canLoadIframes">
					<p class="dc-cc-hidden-content">
						This content has been hidden as it uses cookies that you have not accepted. To view, please update your cookies preferences.
					</p>
				</div> -->
			</div>
		</div>
	</section>
</template>

<script>
import BaseBlock from '@/components/blocks/Base'
export default {
	extends: BaseBlock,
	props: ['data', 'visible', 'ready'],
	data() {
		return {
			defaultColorMode: 'light',
			componentClass: 'job-offers',
			iframeHeight: 500
		}
	},
	components: {
		BlockTitle: () => import('@/components/global/parts/BlockTitle'),
	},
	methods: {
		receiveMessage(evt){
			if (evt.origin === 'https://stem.no') {
				this.iframeHeight = evt.data + 40;
			}
		}
	},
	mounted() {
		window.addEventListener('message', this.receiveMessage, false);
	},
	destroyed() {
		window.removeEventListener('message', this.receiveMessage, false);
	}

}
</script>

<style lang="scss">
	@import "~@/styles/scss/component/job-offers";
</style>